import Footer from 'src/components/Footer'
import Header from 'src/components/Header'

export function PageLayout({ children, breadcrumb }) {
	return (
		<>
			<Header />
			<div className="container ">
				{breadcrumb}
				<div className="page__layout">
					<div>{children}</div>
				</div>
			</div>
			<Footer />
		</>
	)
}
